import { CaretLeft, Plus } from '@phosphor-icons/react'
import { Button, Col, Form, Input, Row, Select } from 'antd'
import { useCreateExternalStep3 } from 'api/External/External'
import ButtonSpinner from 'components/global/ButtonSpinner'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import GenderSelect from 'helper/GenderSelect'
import ItemsToBringModal from 'pages/Events/Views/Common/Modals/ItemsToBring'
import AgeGroup from 'pages/Events/Views/CreateLeague/screens/Step4/Modals/ModalContent/InputComps/AgeGroup'
import React, { useState } from 'react'
import { externalStore } from 'state/event/external'
import { ExternalStep3Payload } from 'types/external/externalEvent'
import StatusModal from '../Step2/Modals/StatusModal'

interface ExternalStep3Props {
  handleNext: () => void
  handleBack: () => void
}

const ExternalStep3: React.FC<ExternalStep3Props> = ({
  handleBack,
  handleNext,
}) => {
  const {
    externalData,
    setExternalData,
    statusModalVisible,
    setStatusModalVisible,
  } = externalStore(store => ({
    externalData: store.externalData,
    setExternalData: store.setExternalData,
    statusModalVisible: store.statusModalVisible,
    setStatusModalVisible: store.setStatusModalVisible,
  }))
  const [form] = Form.useForm()
  const [items, setItems] = useState<string[]>(
    externalData && externalData.itemsToBringIds
      ? externalData.itemsToBringIds
      : [],
  )
  const [itemsToBringModal, setItemsToBringModal] = useState<boolean>(false)
  const { mutate: createExternalStep3, isLoading: createExternalStep3Loading } =
    useCreateExternalStep3()

  const formSchema = {
    minAge: externalData ? externalData.minAge : undefined,
    maxAge: externalData ? externalData.maxAge : undefined,
    gender: externalData ? externalData.genderRestriction : undefined,
    description: externalData ? externalData.description : undefined,
  }

  const handleFinish = values => {
    const payload: ExternalStep3Payload = {
      minAge: values.minAge,
      maxAge: values.maxAge,
      description: values.description,
      genderRestriction: values.gender,
      itemsToBringIds: items,
    }

    createExternalStep3(
      { payload, externalId: externalData._id },
      {
        onSuccess: data => {
          setExternalData(data)
          setStatusModalVisible(true)
        },
      },
    )
  }

  const genders = [
    {
      key: 'male',
      label: 'Male',
    },
    {
      key: 'female',
      label: 'Female',
    },
    {
      key: 'none',
      label: 'No Gender Restriction',
    },
  ]

  return (
    <>
      <div
        className="create-event-main-content-box"
        style={{ margin: '0 auto' }}
      >
        <h2>Step 3: Details</h2>
        <Form form={form} initialValues={formSchema} onFinish={handleFinish}>
          <Row className="mt-10px">
            <Col>
              <label htmlFor="" className="input-label">
                Description
              </label>
              <Form.Item name={'description'} className="form-control">
                <Input.TextArea
                  className="note-field"
                  placeholder="Few words about the external"
                  autoSize={{ minRows: 5, maxRows: 10 }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-10px">
            <Col>
              <h3 className="text-14 w-600">Age Restriction</h3>
              <Row gutter={20} className="mt-10px">
                <Col span={12}>
                  <label htmlFor="" className="input-label">
                    Min age
                  </label>
                  <Form.Item name={'minAge'} className="form-control">
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end radius-12"
                      onWheel={e => e.currentTarget.blur()}
                      onChange={e => {
                        const value = e.target.value
                          ? Number(e.target.value)
                          : undefined
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <label htmlFor="" className="input-label">
                    Max age
                  </label>
                  <Form.Item name={'maxAge'} className="form-control">
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end radius-12"
                      onWheel={e => e.currentTarget.blur()}
                      onChange={e => {
                        const value = e.target.value
                          ? Number(e.target.value)
                          : undefined
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col span={24} className="">
              <label className="input-label">Gender Restriction</label>
              <Form.Item name="gender">
                <Select
                  className="h-50px select-field"
                  placeholder={'Select'}
                  defaultValue={
                    externalData && externalData.gender
                      ? externalData.gender
                      : undefined
                  }
                  onChange={(v, item: any) => {
                    form.setFieldsValue({
                      gender: item.key,
                    })
                  }}
                >
                  {genders.map((gender: { key: string; label: string }) => (
                    <Select.Option key={gender.key} value={gender.key}>
                      {gender.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row className="w-full">
            <div className="w-full" onClick={() => setItemsToBringModal(true)}>
              <IconsTextNavigation
                iconName="ShoppingBagOpen"
                heading="Items to bring"
                details={items.length > 0 ? items.length : 'No items'}
              />
            </div>
          </Row>

          <div className="mt-15px event-button-cont">
            <h5
              className="flex gap-10px align-center pointer"
              onClick={() => handleBack()}
            >
              <CaretLeft size={20} color="#000" />
              <span className="text-15 w-500">Back</span>
            </h5>
            <Button
              className="stepper-button"
              disabled={createExternalStep3Loading}
              //   onClick={handleFinish}
              htmlType="submit"
            >
              {createExternalStep3Loading ? (
                <ButtonSpinner size={20} color="#000" />
              ) : (
                'Create external'
              )}
            </Button>
          </div>
        </Form>
      </div>

      {itemsToBringModal && (
        <ItemsToBringModal
          openModal={itemsToBringModal}
          closeModal={setItemsToBringModal}
          prevItems={items}
          setPrevItems={setItems}
          organizationId={externalData.organizationId}
        />
      )}
      {statusModalVisible && <StatusModal />}
    </>
  )
}

export default ExternalStep3
